import { ReactNode } from 'react';
import styled from '@emotion/styled';
import { useTab } from '@/contexts/tabs/tab-list-context';

interface TabPanelProps {
  children: ReactNode;
  tabId: number;
  tabListId: string;
}

function TabPanel({ children, tabId, tabListId }: TabPanelProps) {
  const [activeTabId] = useTab(tabListId, tabId);
  if (activeTabId !== tabId) return null;

  return (
    <TabPanelContainer
      id={`${tabId}-panel`}
      aria-labelledby={tabId.toString()}
      role='tabpanel'
    >
      {children}
    </TabPanelContainer>
  );
}

const TabPanelContainer = styled('div')``;

export { TabPanel };
